import React from 'react'

import { Checkbox } from '../shapes/Marker'
import { Col, Grid } from '../structure/Grid'
import { useMultiSelectState } from '../multiSelect/MultiSelectHandler'
import CardActions from '../../../../components/actions/CardActions'
import Panel from '../structure/Panel'
import Separator from '../helpers/Separator'

const Context = React.createContext()
const { Provider } = Context
export const useCardData = () => React.useContext(Context)

export const CardHeader = ({ children }) => {
  const { isSelecting } = useMultiSelectState() || {}
  const { isSelected } = useCardData()

  return (
    <Grid gap={0.4} algin="center">
      <Col flex={1}>{children}</Col>
      {isSelecting && <Checkbox value={isSelected} />}
    </Grid>
  )
}

const Card = ({ onClick, actions, children, item, rowKey = 'id', ...props }) => {
  const { isSelecting, selecteds, handleSelect } = useMultiSelectState() || {}
  const isSelected = selecteds.includes(item[rowKey])

  return (
    <Provider value={{ item, isSelected }}>
      <Panel borderColor={isSelected ? 'dark3' : 'light3'} {...props} noPadding>
        <Separator onClick={isSelecting ? handleSelect(item[rowKey]) : onClick} padding={1} {...props}>
          {children}
        </Separator>
        <CardActions actions={actions} />
      </Panel>
    </Provider>
  )
}

export default Card
